import { DiscordLogoIcon } from 'design-configuration/components'
import React from 'react'

export type NavItem = {
  label: React.ReactNode
  value: string
  subItems?: NavItem[]
  disableDismiss?: boolean
} & (
  | { href: string; onClick?: React.MouseEventHandler<HTMLAnchorElement | HTMLButtonElement> }
  | { href?: string; onClick: React.MouseEventHandler<HTMLAnchorElement | HTMLButtonElement> }
)

export const NAV_ITEMS: Array<NavItem> = [
  {
    label: 'Calendar',
    value: 'calendar',
    href: '/calendar'
  },
  {
    label: 'Collections',
    href: '/discover',
    value: 'collections',
    subItems: [
      {
        label: 'Discover all',
        value: 'discover-all',
        href: '/discover'
      },
      {
        label: 'AB[500]',
        value: 'ab-500',
        href: '/discover/ab-500'
      },
      {
        label: 'Curated',
        value: 'curated-collections',
        href: '/discover/curated'
      },
      {
        label: 'Studio',
        value: 'studio-collections',
        href: '/discover/studio'
      },
      {
        label: 'Presents',
        value: 'presents-collections',
        href: '/discover/presents'
      },
      {
        label: 'Engine',
        value: 'engine-collections',
        href: '/discover/engine'
      }
    ]
  },
  {
    label: 'Artists',
    href: '/artists',
    value: 'artists',
    subItems: [
      {
        label: 'Featured artists',
        value: 'featured-artist',
        href: '/artists'
      },
      {
        label: 'All artists',
        value: 'all-artists',
        href: '/artists?tab=All+artists'
      },
      {
        label: 'Apply as an artist',
        value: 'artist-application',
        href: '/marketplace/studio/apply'
      },
      {
        label: 'Apply for artist residency',
        value: 'artist-residency',
        href: '/marketplace/studio/apply/residency'
      }
    ]
  },
  {
    label: 'Learn',
    href: '/articles',
    value: 'learn',
    subItems: [
      {
        label: 'The Journal',
        value: 'journal',
        href: '/articles'
      },
      {
        label: 'How to purchase',
        value: 'how-to-purchase',
        href: '/articles/art-blocks-how-to-purchase'
      },
      {
        label: 'Technical docs',
        value: 'technical-docs',
        href: 'https://docs.artblocks.io'
      }
    ]
  },
  {
    label: 'Marketplace',
    href: '/secondary-marketplace',
    value: 'marketplace',
    subItems: [
      {
        label: 'Secondary marketplace',
        value: 'secondary-marketplace',
        href: '/secondary-marketplace'
      },
      {
        label: 'Listing activity',
        value: 'activity',
        href: '/marketplace/activity'
      },
      {
        label: 'Collection rankings',
        value: 'rankings',
        href: '/marketplace/rankings'
      }
    ]
  },
  {
    label: 'About',
    href: '/articles/about-art-blocks',
    value: 'about',
    subItems: [
      {
        label: 'About us',
        value: 'about-us',
        href: '/articles/about-art-blocks'
      },
      {
        label: 'Our on-chain vision',
        value: 'our-on-chain-vision',
        href: '/marketplace/onchain'
      },
      {
        label: 'Timeline',
        value: 'timeline',
        href: '/timeline'
      }
    ]
  },
  {
    label: <DiscordLogoIcon className="w-sm h-sm fill-on-surface" />,
    value: 'discord',
    href: 'https://discord.gg/artblocks'
  }
]
